import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import CustomInput from '../../components/form/CustomInput'
import CustomButtonConfirm from '../../components/form/CustomButtonConfirm'
import { loginSuccess } from '../../store/auth/login/action'
import { postLoginToken } from '../../helpers/configRoutes/backend_helper'

const Login = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const validation = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Correo electrónico no válido')
                .required('Ingresa tu correo electrónico'),
            password: Yup.string().required('Ingresa tu contraseña'),
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true)

            const response = await postLoginToken(values)

            if (response.status === true) {
                dispatch(loginSuccess(response))
                navigate('/')
            } else if (response.errors?.length) {
                setErrors(response.errors)
            }

            setLoading(false)
        },
    })

    return (
        <div className="min-h-screen w-full bg-cs-bg flex flex-col justify-center px-5">

            {/* Logo */}
            <div className="flex justify-center mb-10">
                <img
                    src="/images/logo.png"
                    alt="Logo"
                    className="h-20 w-auto"
                />
            </div>

            {/* Card */}
            <div className="bg-cs-surface rounded-2xl p-6 shadow-sm animate-fadeIn">
                <h1 className="text-lg font-semibold text-cs-dark mb-1">
                    Bienvenido
                </h1>
                <p className="text-sm text-cs-muted mb-6">
                    Inicia sesión para continuar
                </p>

                <form
                    className="flex flex-col gap-4"
                    onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                    }}
                >
                    <CustomInput
                        placeholder="Correo electrónico"
                        type="email"
                        name="email"
                        error={validation.errors.email}
                        value={validation.values.email}
                        handleChange={validation.handleChange}
                    />

                    <CustomInput
                        placeholder="Contraseña"
                        type="password"
                        name="password"
                        error={validation.errors.password}
                        value={validation.values.password}
                        handleChange={validation.handleChange}
                    />

                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={() => navigate('/forgot-password')}
                            className="text-sm text-cs-primary hover:underline"
                        >
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>

                    <CustomButtonConfirm
                        loading={loading}
                        textLoad="Ingresando…"
                        text="Entrar"
                        className="w-full mt-2"
                    />
                </form>
            </div>

            {/* Footer opcional */}
            <p className="text-center text-xs text-cs-muted mt-8">
                © {new Date().getFullYear()} Cargo Smart
            </p>
        </div>
    )
}

export default Login